import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ApprovalsService } from '../approvals.service';
import { OnDestroyMixin, untilComponentDestroyed } from '@w11k/ngx-componentdestroyed';
import { TSIconModule, TsSnackbarService } from 'tsui';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { ApprovalDeclineModalComponent } from '../approval-decline-modal/approval-decline-modal.component';
import { filter, switchMap } from 'rxjs';
import { Approval, ApprovalStatus } from '../approvals.types';
import { Dialog } from '@angular/cdk/dialog';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';

@Component({
  selector: 'approval-footer',
  standalone: true,
  imports: [CommonModule, TSIconModule, MatDialogModule, ApprovalDeclineModalComponent],
  templateUrl: './approval-footer.component.html',
  styleUrls: ['./approval-footer.component.scss'],
})
export class ApprovalFooterComponent extends OnDestroyMixin {
  @Input() approval: Approval;

  constructor(
    private approvalService: ApprovalsService,
    private dialog: Dialog,
    private cdr: ChangeDetectorRef,
    private snackBar: TsSnackbarService,
  ) {
    super();
  }

  get isPending(): boolean {
    return this.approval?.status === ApprovalStatus.NOT_YET;
  }

  get isApproved(): boolean {
    return this.approval?.status === ApprovalStatus.APPROVED;
  }

  get isDeclined(): boolean {
    return this.approval?.status === ApprovalStatus.DECLINED;
  }

  approve(): void {
    if (this.isApproved) {
      return;
    }

    this.approvalService
      .approve(this.approval.id)
      .pipe(untilComponentDestroyed(this))
      .subscribe({
        next: (approval) => {
          this.approval = approval;
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.error(error);
          this.snackBar.open(error.error.message, 'error');
        },
      });
  }

  decline(): void {
    if (this.isDeclined) {
      return;
    }

    this.dialog
      .open(ApprovalDeclineModalComponent, {
        ...TsDialogComponent.getDefaultDialogConfig(),
      })
      .closed.pipe(
        untilComponentDestroyed(this),
        filter((res) => !!res),
        switchMap((res: { note: string }) => this.approvalService.decline(this.approval.id, res.note)),
      )
      .subscribe({
        next: (approval) => {
          this.approval = approval;
          this.cdr.detectChanges();
        },
        error: ({ error }) => {
          console.error(error);
          this.snackBar.open(error.error.message, 'error');
        },
      });
  }
}
